import { ThunkDispatch } from 'redux-thunk';

import { LiveApi } from 'api';
import * as actionTypes from 'shared/store/action-types';
import { createAction } from 'shared/util/utility';

const fetchLiveEvents = () => {
	return async (dispatch: ThunkDispatch<{}, {}, any>) => {
		try {
			const response = await LiveApi.liveMatchEventCount();
			const count = response.data.data.eventsCount.reduce((acc: number, item: any) => acc + item.eventsCount, 0);
			dispatch(
				createAction(actionTypes.SET_LIVE_EVENT, {
					liveEvents: response.data.data.eventsCount,
					count,
				}),
			);
		} catch (err) {
			console.error(err);
		}
	};
};

const liveChat = (param: string) => {
	return async (dispatch: ThunkDispatch<any, any, any>) => {
		dispatch(createAction(actionTypes.LIVE_CHAT, { isLiveChatVisible: param }));
	};
};

export { fetchLiveEvents, liveChat };
